import { render, staticRenderFns } from "./WidgetActions.vue?vue&type=template&id=446af190&scoped=true"
import script from "./WidgetActions.vue?vue&type=script&lang=js"
export * from "./WidgetActions.vue?vue&type=script&lang=js"
import style0 from "./WidgetActions.vue?vue&type=style&index=0&id=446af190&prod&scoped=true&lang=scss"
import style1 from "./WidgetActions.vue?vue&type=style&index=1&id=446af190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446af190",
  null
  
)

export default component.exports